import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 结束播放音频
export function stopAudio(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(APINames.Native.STOP_AUOID, option);
}
